<template>
  <el-dialog title="1 级轮询备用 API" :visible="visible" width="720px" @close="$emit('close')">
    <el-alert type="warning" :closable="false" show-icon
              title="仅作用于当前连接的后端，重启会清空备用名单。请连接用户实际生图的后端后配置。" />
    <p>备用号必须已在 API 管理中登记为可用的 0／2 级，加入名单后仍在原池使用。</p>
    <p>启用时只允许一个有效 1 级号。该号返回 402 后，按名单寻找可用备用号并交换级别；备用号的原级别以交换时查询结果为准。在途请求及冷却完成后才可从新池借用。</p>
    <el-alert v-if="unavailable" type="error" :closable="false" title="状态获取失败，请刷新；暂不能修改轮换配置。" />
    <template v-if="status">
      <p>本次后端运行标识：<code>{{ status.instanceId }}</code></p>
      <p><el-tag :type="status.enabled ? 'success' : 'info'">{{ status.enabled ? '轮换已启用' : '轮换已暂停' }}</el-tag> {{ status.message }}</p>
      <p v-if="status.exhaustedId">等待替换的耗尽号 ID：{{ status.exhaustedId }}</p>
      <p v-if="status.lastSwap">最近交换：{{ status.lastSwap.exhaustedId }} → {{ status.lastSwap.returnLevel }} 级，{{ status.lastSwap.promotedId }} → 1 级</p>
      <el-table :data="status.queue" size="mini" max-height="240">
        <el-table-column type="index" label="顺序" width="55" />
        <el-table-column prop="id" label="记录 ID" width="90" />
        <el-table-column label="Token 指纹" width="145"><template slot-scope="s">{{ s.row.fingerprint.slice(0, 12) }}</template></el-table-column>
        <el-table-column prop="currentLevel" label="当前级别" width="90" />
        <el-table-column label="登记状态"><template slot-scope="s">{{ s.row.eligible ? '可候选（仍检查隔离状态）' : '失效，将跳过' }}</template></el-table-column>
        <el-table-column label="操作" width="65"><template slot-scope="s"><el-button type="text" :disabled="blocked" @click="remove(s.row.id)">移除</el-button></template></el-table-column>
      </el-table>
    </template>
    <el-input v-model="tokens" type="textarea" :rows="4" :disabled="busy" autocomplete="off"
              placeholder="每行一枚已登记的 0／2 级 Token，可带 Bearer 前缀；按输入顺序追加，最多 200 枚。请提前确认备用号有积分。" />
    <p>不提前查询官方余额；备用号如果也返回 402，会继续寻找下一枚。当前失败请求不自动重发，用户重试即可。</p>
    <div slot="footer">
      <el-button :disabled="busy || loading" @click="refresh">刷新状态</el-button>
      <el-button :disabled="blocked || !tokens.trim()" :loading="busy" @click="append">加入备用队列</el-button>
      <el-button :disabled="blocked" @click="toggle">{{ status && status.enabled ? '暂停轮换' : '启用轮换' }}</el-button>
      <el-button :disabled="blocked" @click="retry">充值后允许重试</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';
const base = '/api/admin/apiKeys/level-one-rotation';
export default {
  props: { visible: Boolean },
  data() { return { tokens: '', status: null, busy: false, loading: false, unavailable: true, timer: null }; },
  computed: { blocked() { return this.busy || this.loading || this.unavailable || !this.status; } },
  watch: {
    visible(value) {
      if (value) { this.refresh(); this.timer = window.setInterval(() => this.refresh(), 5000); }
      else { window.clearInterval(this.timer); this.timer = null; this.tokens = ''; }
    }
  },
  beforeDestroy() { window.clearInterval(this.timer); },
  methods: {
    async call(method, suffix = '', data) {
      const response = await axios({ method, url: base + suffix, data,
        headers: { token: this.$cookies.get('token') }, timeout: 15000 });
      if (Number(response.data.code) !== 200) throw new Error(response.data.msg || '操作失败');
      return response.data.data;
    },
    async refresh() {
      if (this.busy || this.loading) return;
      this.loading = true;
      try {
        const next = await this.call('get');
        if (next.lastSwap?.at !== this.status?.lastSwap?.at) this.$emit('changed');
        this.status = next;
        this.unavailable = false;
      }
      catch (_) { this.unavailable = true; }
      finally { this.loading = false; }
    },
    async mutate(method, suffix, data) {
      if (this.blocked) return false;
      this.busy = true;
      try {
        this.status = await this.call(method, suffix, data);
        this.unavailable = false;
        this.$emit('changed');
        return true;
      } catch (error) {
        this.$message.error(error.response?.data?.msg || error.message || '操作失败，请刷新状态确认');
        this.unavailable = true;
        return false;
      } finally { this.busy = false; }
    },
    async append() {
      const tokens = this.tokens.split(/\r?\n/).map(t => t.trim()).filter(Boolean);
      if (await this.mutate('post', '/queue', { tokens })) this.tokens = '';
    },
    remove(id) { return this.mutate('delete', '/queue/' + id); },
    toggle() { return this.mutate('put', '/enabled', { enabled: !this.status.enabled }); },
    async retry() {
      try {
        await this.$confirm('确认已给耗尽号充值？此操作清除本后端的积分耗尽标记，允许再次尝试；不清除冷却或 403 隔离。', '充值后允许重试');
        await this.mutate('post', '/retry-after-top-up');
      } catch (_) { /* Cancelled. */ }
    }
  }
};
</script>
